import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../globalModule/assets/close-circle.svg'
import _imports_1 from './../../globalModule/assets/ask_question.svg'


const _withScopeId = n => (_pushScopeId("data-v-0421ca30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, "Git Menu", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "body-div"
}
const _hoisted_7 = { class: "input-div" }
const _hoisted_8 = { class: "input-div" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "body-div"
}
const _hoisted_11 = { class: "input-div" }
const _hoisted_12 = {
  key: 0,
  class: "input-div"
}
const _hoisted_13 = {
  key: 1,
  class: "input-div"
}
const _hoisted_14 = {
  key: 2,
  class: "input-div"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_16 = { class: "input-div" }
const _hoisted_17 = { class: "button-div" }
const _hoisted_18 = { class: "button-div" }
const _hoisted_19 = {
  key: 3,
  class: "commit-success"
}
const _hoisted_20 = {
  key: 4,
  class: "commit-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextBubble = _resolveComponent("TextBubble")!
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ]),
    (!_ctx.gitWsDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_TextBubble, { text: 'Create a new git repository for this workspace below. You may also instead select an existing repository on this git account to push to.' }, null, 8, ["text"]),
          _createTextVNode(" Create a new repository: "),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(" Name: "),
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              type: "text",
              placeholder: "New Repository Name",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newRepoName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.newRepoName]
            ]),
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createNewRepo()))
            }, " Create New Repo ")
          ]),
          _createTextVNode(" Choose an existing repository: "),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SearchableDropDown, {
              options: 
          _ctx.gitRepos.map((repo) => {
            return { id: repo.id, name: `${repo.owner}/${repo.name}` };
          })
        ,
              maxItem: 15,
              onSelected: _cache[3] || (_cache[3] = 
          (repo) => {
            _ctx.selectedRepo = _ctx.gitRepos.find(
              (searchRepo) => searchRepo.id === repo.id
            );
          }
        )
            }, null, 8, ["options"]),
            _createElementVNode("button", {
              class: "rectangle-button",
              disabled: !_ctx.selectedRepo,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.chooseExistingWorkspace()))
            }, " Choose this repo ", 8, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.gitWsDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(" Current repository: " + _toDisplayString(_ctx.gitWsDetails && _ctx.gitWsDetails.repoName) + " ", 1),
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectDifferentRepo()))
            }, " Choose a different Repository ")
          ]),
          (!_ctx.changingBranch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createTextVNode(" Current branch: " + _toDisplayString(_ctx.gitBranchName) + " ", 1),
                _createElementVNode("button", {
                  class: "rectangle-button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changingBranch = !_ctx.changingBranch))
                }, " Change branch ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.changingBranch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createTextVNode(" Select branch: "),
                _createVNode(_component_SearchableDropDown, {
                  options: _ctx.gitBranches,
                  maxItem: 5,
                  onSelected: _cache[7] || (_cache[7] = 
          (branch) => {
            _ctx.selectedBranch = branch;
          }
        )
                }, null, 8, ["options"]),
                _createElementVNode("button", {
                  class: "rectangle-button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.chooseSelectedBranch()))
                }, " Select Branch ")
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.changingBranch ? 'or' : '') + " ", 1),
          (_ctx.changingBranch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createTextVNode(" Create new branch: "),
                _withDirectives(_createElementVNode("input", {
                  class: "input-box",
                  placeholder: "Branch Name",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newBranchName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newBranchName]
                ]),
                _createElementVNode("button", {
                  class: "rectangle-button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createNewBranch()))
                }, " Create New Branch ")
              ]))
            : _createCommentVNode("", true),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createTextVNode(" Commit message: "),
            _withDirectives(_createElementVNode("input", {
              class: "input-box",
              placeholder: "Commit message",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.commitMessage) = $event))
            }, null, 512), [
              [_vModelText, _ctx.commitMessage]
            ]),
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.commitAndPush()))
            }, " Commit and Push to origin ")
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pullFromOrigin()))
            }, " Pull from origin ")
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.viewGitRepo()))
            }, " View Repository ")
          ]),
          (!_ctx.commitError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.commitText), 1))
            : _createCommentVNode("", true),
          (_ctx.commitError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.commitText), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}